import { axiosInstance as request } from '@api/rest.service'

const api = '/license-term-labels'

/**
 * @description GET /license-term-labels/create
 * @returns {AxiosPromise<any>}
 */
export const GET_TERM_LABELS_CREATE = () => request.get(`${api}/create`)

/**
 * @description GET /license-term-labels
 * @returns {AxiosPromise<any>}
 */
export const GET_TERM_LABELS = () => request.get(api)

/**
 * @description POST /license-term-labels
 * @returns {AxiosPromise<any>}
 */
export const CREATE_TERM_LABEL = payload => request.post(api, payload)

/**
 * @description GET /license-term-labels/{id}/delete-confirmation
 * @returns {AxiosPromise<any>}
 */
export const GET_TERM_LABEL_CONFIRMATION = id => request.get(`${api}/${id}/delete-confirmation`)

/**
 * @description PATCH /license-term-labels/{id}
 * @returns {AxiosPromise<any>}
 */
export const MODIFY_TERM_LABEL = (id, payload) => request.patch(`${api}/${id}`, payload)

/**
 * @description DELETE /license-term-labels/{id}
 * @returns {AxiosPromise<any>}
 */
export const DELETE_TERM_LABEL = id => request.delete(`${api}/${id}`)
